import { render, staticRenderFns } from "./PostingCardBody.vue?vue&type=template&id=1febca9d&scoped=true"
import script from "./PostingCardBody.vue?vue&type=script&lang=ts"
export * from "./PostingCardBody.vue?vue&type=script&lang=ts"
import style0 from "./PostingCardBody.vue?vue&type=style&index=0&id=1febca9d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febca9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1febca9d')) {
      api.createRecord('1febca9d', component.options)
    } else {
      api.reload('1febca9d', component.options)
    }
    module.hot.accept("./PostingCardBody.vue?vue&type=template&id=1febca9d&scoped=true", function () {
      api.rerender('1febca9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/postingComponents/PostingCardBody.vue"
export default component.exports